<button
   (click)="toggleFilterPopup()"
   [isTooltipVisible]="isFilterListOpen$ | async"
   [tooltipTemplate]="agentListFilterTooltip"
   [style.height]="'100%'"
   [style.min-width]="'105px'"
   tooltipClass="tooltip-popup"
   kendoButton
   kendoTooltip
   position="bottom"
   class="sam-grid-filter-button"
>
   <fa-icon [icon]="filterIcon" [fixedWidth]="true" class="filter-icon"></fa-icon>
   <div class="sam-button-text">
      {{ 'common.filter' | translate }}
      <ng-container *ngIf="(numSelected$ | async) > 0"> ({{ numSelected$ | async }}) </ng-container>
   </div>
   <ng-template #agentListFilterTooltip>
      <div (samwebOutsideClick)="toggleFilterPopup()">
         <samweb-loading-indicator
            fxFlexFill
            [longRunningContextCategories]="['GRID_FILTERS']"
            [brickInstanceId]="this.brickInstanceId"
            [runForever]="false"
         >
            <div fxLayout="column" class="sam-margin">
               <div fxFlex="1" *ngFor="let value of availableValues$ | async" class="sam-filter">
                  <label class="k-checkbox-label" for="filterValue-{{ value.filterKey }}">
                     <input
                        type="checkbox"
                        [checked]="isFilterSelected$(value) | async"
                        (click)="changeFilterValue(value, $event)"
                        id="filterValue-{{ value.filterKey }}"
                        class="k-checkbox sam-margin-right"
                     />
                     <fa-icon [icon]="value.icon" [class]="value.cssClass" [fixedWidth]="true"></fa-icon>
                     <span>
                        {{ value.translationKey | translate }}
                     </span>
                  </label>
               </div>
            </div>
         </samweb-loading-indicator>
      </div>
   </ng-template>
</button>
